import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc1e957"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document-viewer" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "width-100 flex items-center justify-end gap-1" }
const _hoisted_4 = {
  class: "document-viewer__img-container",
  tabindex: "0"
}
const _hoisted_5 = ["data"]
const _hoisted_6 = {
  key: 1,
  class: "img-loader width-60 height-50 rounded-1"
}
const _hoisted_7 = ["onerror", "src"]

import { onUpdated, ref, watch } from 'vue';
import BtnIcon from '../BtnIcon/BtnIcon.vue';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const IMAGE_INITIAL_SIZE = '60%'; // Update this in css class
const IMAGE_ZOOMED_SIZE = '100%';
const IMAGE_ROTATION_DEGREES = 90;


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentViewer',
  props: {
    imageInfo: {},
    imageUrl: {},
    isPdf: { type: Boolean },
    fileType: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const brokenImagePath = require('./brokenImage.png');



const image = ref<HTMLImageElement>();
const imageRotation = ref(0);
const imageScale = ref(IMAGE_INITIAL_SIZE);

watch(imageRotation, () => {
	image.value!.style.transformOrigin = '50% 50%';
	image.value!.style.transform = `rotate(${imageRotation.value}deg)`;
});

watch(imageScale, () => {
	image.value!.style.width = imageScale.value;
});

onUpdated(() => {
	imageRotation.value = 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(BtnIcon, {
          "icon-name": "bx-zoom-in",
          ariaLabel: "Zoom image in",
          disabled: imageScale.value === IMAGE_ZOOMED_SIZE || !_ctx.imageUrl,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (imageScale.value = IMAGE_ZOOMED_SIZE))
        }, null, 8, ["disabled"]),
        _createVNode(BtnIcon, {
          "icon-name": "bx-zoom-out",
          ariaLabel: "Zoom image out",
          disabled: imageScale.value === IMAGE_INITIAL_SIZE || !_ctx.imageUrl,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (imageScale.value = IMAGE_INITIAL_SIZE))
        }, null, 8, ["disabled"]),
        _createVNode(BtnIcon, {
          "icon-name": "bx-rotate-right",
          ariaLabel: "Rotate image right",
          disabled: !_ctx.imageUrl,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (imageRotation.value += IMAGE_ROTATION_DEGREES))
        }, null, 8, ["disabled"])
      ], 512), [
        [_vShow, !_ctx.isPdf]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.imageUrl && _ctx.isPdf)
        ? (_openBlock(), _createElementBlock("object", {
            key: 0,
            ref_key: "image",
            ref: image,
            data: _ctx.imageUrl,
            class: "mt-2",
            width: "100%",
            height: "100%",
            type: "application/pdf",
            role: "document",
            title: "PDF document",
            "aria-label": "PDF document"
          }, " PDF display ", 8, _hoisted_5))
        : (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6))
          : (_ctx.imageUrl && !_ctx.isPdf)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                ref_key: "image",
                ref: image,
                class: "document-viewer__img-container__img",
                "no-referrer": "",
                onerror: `this.onerror=null;this.src='${_unref(brokenImagePath)}';`,
                src: _ctx.imageUrl,
                alt: "Image of document"
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})